import React from "react";
import { Link } from "react-router-dom";
import { Brand } from "../Brand";
import { NavLink } from "./SiteHeader";

// Pagine servizio (sottopagine del menu) prima, poi i destinatari (Consulenti, Aziende).
const featureLinks = (pages) => {
  const groups = pages.filter((p) => (p.children || []).length > 0);
  const ordered = [...groups.filter((p) => p.slug !== "destinatari"), ...groups.filter((p) => p.slug === "destinatari")];
  return ordered.flatMap((p) => p.children.map((c) => ({ slug: c.slug, title: c.title })));
};

const LINK = "hover:text-[#ff7e00] transition-colors";

// Footer del sito pubblico con blocco "Funzionalità" (link reali a tutte le pagine servizio).
export const SiteFooter = ({ pages = [], onHome = false }) => {
  const features = featureLinks(pages);
  return (
    <footer className="max-w-6xl mx-auto px-6 py-12 border-t border-white/10 text-center" data-testid="site-footer">
      <Link to="/" data-testid="footer-brand" className="inline-block"><Brand dark className="text-[20px]" /></Link>
      <p className="text-[13px] text-gray-500 mt-4">Portale HR aziendale · Presenze, ferie, welfare, formazione e trasferte in un unico posto.</p>
      {features.length > 0 && (
        <nav className="mt-8" aria-label="Funzionalità" data-testid="footer-features">
          <p className="text-[12px] font-black tracking-widest uppercase text-[#ffb066] mb-3">Funzionalità</p>
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[13px] font-semibold text-gray-300">
            {features.map((f) => (
              <li key={f.slug}><Link to={`/p/${f.slug}`} data-testid={`footer-link-${f.slug}`} className={LINK}>{f.title}</Link></li>
            ))}
          </ul>
        </nav>
      )}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[13px] font-semibold text-gray-400" data-testid="landing-footer-legal">
        <NavLink item={{ anchor: "contatti", to: "/#contatti" }} onHome={onHome} testid="footer-contatti-link" className={LINK}>Contatti</NavLink>
        <Link to="/privacy-policy" data-testid="footer-privacy-link" className={LINK}>Privacy Policy</Link>
        <Link to="/cookie-policy" data-testid="footer-cookie-link" className={LINK}>Cookie Policy</Link>
        <button type="button" onClick={() => window.dispatchEvent(new Event("open-cookie-preferences"))} data-testid="footer-cookie-prefs" className={LINK}>Preferenze cookie</button>
      </div>
      <p className="text-[12px] text-gray-500 mt-6" data-testid="footer-owner">Titolare: Marco Paparelli · Viale Regina Margherita, 46 – 00198 Roma · P.IVA 05042811009</p>
      <p className="text-[12px] text-gray-500 mt-2">© {new Date().getFullYear()} JOBTIMEHR. Tutti i diritti riservati.</p>
    </footer>
  );
};

export default SiteFooter;
